import React, { useEffect } from 'react'

import Navigation from './Navigation'
import { supabase } from 'clients/supabase'

interface Props {
	/**
	 * The navigation component that gets passed down from the Layout component
	 */
	subNav?: boolean
}

interface Banner {
	id: number
	text: string
	link: string | null
	link_text: string | null
	sort_order: number | null
}

const Header = ({ subNav }: Props) => {
	const [banner, setBanner] = React.useState<Banner>()
	const [bannerError, setBannerError] = React.useState<string | null>(null)

	useEffect(() => {
		supabase
			.from('website_banner_messages')
			.select('*')
			.then((res) => {
				try {
					if (res.error) throw new Error(res.error.message)
					console.log(res)
					if (res.data && res.data.length > 0) {
						setBanner(res.data[Math.floor(Math.random() * res.data.length)] as Banner)
					}
				} catch (error: any) {
					setBannerError(error.message)
				}
			})
	}, [])

	return (
		<header id="header" className={`nav-gradient relative z-10 ${subNav ? '' : 'shadow-md'}`}>
			{!bannerError && (
				<div className="bg-white shadow h-10">
					{banner && (
						<div className="mx-auto w-full py-2 px-2 lg:max-w-screen-lg xl:max-w-screen-xl">
							<p className="font-semibold text-center">
								🎉 {banner.text} | {banner?.link && <a href={banner?.link || ''}>{banner.link_text || 'Learn More'}</a>}
							</p>
						</div>
					)}
				</div>
			)}
			<Navigation />
		</header>
	)
}

export default Header
